import { SHIFT_CHANGE_ROOT_BRANCH } from '../constants/shifts.constant';

const initialState = {
  rootBranch: {},
};

// eslint-disable-next-line react-refresh/only-export-components
export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SHIFT_CHANGE_ROOT_BRANCH: {
      return {
        ...state,
        rootBranch: payload,
      };
    }
    default: {
      return state;
    }
  }
};

export { initialState };
